// extracted by mini-css-extract-plugin
export default {"wrapper":"BackToTop_wrapper__ju0xD"};